import React, { useState, useEffect } from "react";
import { USER_DATA } from "../../utils/constants";
import RepositoriesScreen from "./Profile.screen";
import { updateProfile } from "../../api/user";
import { toast } from "react-toastify";
import { UserTypes } from "../../interfaces/UserTypes";

export default function ProfileContainer() {
  const [user, setUser] = useState<UserTypes>();

  const [name, setName] = useState<string>(user?.name || "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [githubUser, setGithubUser] = useState("");
  const [githubToken, setGithubToken] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}')
    setUser(userData)
    setName(userData.name)
    setEmail(userData.email)
    setGithubUser(userData.githubUser)
    setGithubToken(userData.githubToken)
  }, []);

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault();

    const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || '{}').uid;

    const data = {
      githubToken: githubToken,
      githubUser: githubUser,
    }

    await updateProfile(user_uuid, data)
      .then(() => {
        toast.success('Usuário atualizado com sucesso!');

        const userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}')
        userData.githubToken = githubToken
        userData.githubUser = githubUser
        localStorage.setItem(USER_DATA, JSON.stringify(userData))
      })

    setLoading(false);
  }

  return (
    <RepositoriesScreen
      loading={loading}
      name={name}
      email={email}
      githubUser={githubUser}
      githubToken={githubToken}
      setGithubToken={setGithubToken}
      password={password}
      setPassword={setPassword}
      confirmPassword={confirmPassword}
      setConfirmPassword={setConfirmPassword}
      handleSubmit={handleSubmit}
      setGithubUser={setGithubUser}
    />
  );
}
